export default __webpack_public_path__ + "static/media/cg.03f54ddb.svg";